var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80005 9.19983C3.80005 9.43852 3.70516 9.66743 3.53638 9.83621C3.36759 10.005 3.13872 10.0998 2.90002 10.0998C2.66133 10.0998 2.43233 10.005 2.26355 9.83621C2.09477 9.66743 2 9.43852 2 9.19983C2 8.96113 2.09477 8.7322 2.26355 8.56342C2.43233 8.39463 2.66133 8.2998 2.90002 8.2998C3.13872 8.2998 3.36759 8.39463 3.53638 8.56342C3.70516 8.7322 3.80005 8.96113 3.80005 9.19983Z",
    fill: "#595F72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 9.19983C3.80005 9.43852 3.70516 9.66743 3.53638 9.83621C3.36759 10.005 3.13872 10.0998 2.90002 10.0998C2.66133 10.0998 2.43233 10.005 2.26355 9.83621C2.09477 9.66743 2 9.43852 2 9.19983C2 8.96113 2.09477 8.7322 2.26355 8.56342C2.43233 8.39463 2.66133 8.2998 2.90002 8.2998C3.13872 8.2998 3.36759 8.39463 3.53638 8.56342C3.70516 8.7322 3.80005 8.96113 3.80005 9.19983Z",
    stroke: "#595F72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80005 2.89999C3.80005 3.13869 3.70516 3.36761 3.53638 3.53639C3.36759 3.70517 3.13872 3.8 2.90002 3.8C2.66133 3.8 2.43233 3.70517 2.26355 3.53639C2.09477 3.36761 2 3.13869 2 2.89999C2 2.6613 2.09477 2.43239 2.26355 2.26361C2.43233 2.09483 2.66133 2 2.90002 2C3.13872 2 3.36759 2.09483 3.53638 2.26361C3.70516 2.43239 3.80005 2.6613 3.80005 2.89999Z",
    fill: "#595F72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 2.89999C3.80005 3.13869 3.70516 3.36761 3.53638 3.53639C3.36759 3.70517 3.13872 3.8 2.90002 3.8C2.66133 3.8 2.43233 3.70517 2.26355 3.53639C2.09477 3.36761 2 3.13869 2 2.89999C2 2.6613 2.09477 2.43239 2.26355 2.26361C2.43233 2.09483 2.66133 2 2.90002 2C3.13872 2 3.36759 2.09483 3.53638 2.26361C3.70516 2.43239 3.80005 2.6613 3.80005 2.89999Z",
    stroke: "#595F72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80005 15.4996C3.80005 15.7383 3.70516 15.9672 3.53638 16.136C3.36759 16.3048 3.13872 16.3996 2.90002 16.3996C2.66133 16.3996 2.43233 16.3048 2.26355 16.136C2.09477 15.9672 2 15.7383 2 15.4996C2 15.2609 2.09477 15.032 2.26355 14.8632C2.43233 14.6944 2.66133 14.5996 2.90002 14.5996C3.13872 14.5996 3.36759 14.6944 3.53638 14.8632C3.70516 15.032 3.80005 15.2609 3.80005 15.4996Z",
    fill: "#595F72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 15.4996C3.80005 15.7383 3.70516 15.9672 3.53638 16.136C3.36759 16.3048 3.13872 16.3996 2.90002 16.3996C2.66133 16.3996 2.43233 16.3048 2.26355 16.136C2.09477 15.9672 2 15.7383 2 15.4996C2 15.2609 2.09477 15.032 2.26355 14.8632C2.43233 14.6944 2.66133 14.5996 2.90002 14.5996C3.13872 14.5996 3.36759 14.6944 3.53638 14.8632C3.70516 15.032 3.80005 15.2609 3.80005 15.4996Z",
    stroke: "#595F72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEditorIcon);
export default __webpack_public_path__ + "static/media/userEditorIcon.c1b4c685b71817a9058f78b552d391cd.svg";
export { ForwardRef as ReactComponent };